<template>
<div>
<navigation></navigation>
<!--Main contents-->
<div class="box_center" id="page_x">
  <h2 class="shadow" style="float: left">Blog</h2>
  <adsense
      ad-client="ca-pub-8213113866781504"
      ad-slot="7783278999"
      ad-layout-key="-8i+1w-dq+e9+ft"
      ad-format="fluid">
  </adsense>
  <ul class="articles">
    <li v-for="post in posts">
      <div class="article">
      <a href="#" class="title_article">{{post.title}}</a>
      <p class="text_article" v-html="post.content"></p>
          <b>{{post.date}}</b>
          </div>
      <div class="separator"></div>
    </li>
  </ul>
</div>
<!--Main contents Ends-->
</div>
</template>

<script>
import PostRepository from '../data/post.repository.js'
import Nav from '../components/Nav'
import Adsense from '../components/adsense.vue'
export default {
  components: {
    'navigation': Nav,
    'adsense': Adsense
  },
  data () {
    return {
      category: '',
      posts: [],
      page: 0,
      total: 0,
      current: 0
    }
  },
  methods: {
    next () {
      if (this.current >= this.total && this.page !== 0) return
      PostRepository.get(this.page + 1, this.category, this.month, this.year).then((data) => {
        this.total = data.total
        this.current = data.to
        this.page = data.current_page
        this.posts = this.posts.concat(data.data)
      })
    }
  },
  created () {
    this.next()
  },
  metaInfo: {
    title: 'Blog'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Blog.vue?f9d8cf94